import {
  handleErrors,
  calculateRefreshTimeByExpirationsTime,
} from '@/helpers/index';
import AuthSubUserService from '@/services/api/AuthSubUserService';

export default {
  actions: {
    subUserLogin({ commit, dispatch }, token) {
      return new Promise((resolve, reject) => {
        AuthSubUserService.login(token)
          .then(data => {
            commit('updateUserAccessTokenExpirationTime', calculateRefreshTimeByExpirationsTime(data.expires_in));
            commit('updateToken', data.access_token);
            dispatch('authorizeSpotifyApp');
            dispatch('fetchSubUser');

            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },

    fetchSubUser({ commit }) {
      AuthSubUserService.me()
        .then(data => {
          commit('updateUser', data);
        })
        .catch(handleErrors);
    },

  },

};
